export enum OrderStatusEnum {
  CLOSED = 0,
  OPEN = 1,
  EXPIRED = 2,
  BOOKED = 3,
  COMPLETED = 4,
  CANCELLED = 5
}
